import isNumber from "lodash-es/isNumber";
import { DateTimeDTO } from "./shipmentCard.types";

export enum PaymentsModalType {
  "FREE" = "FREE",
  "PAY" = "PAY",
}

export type SubscriptionDataModel = {
  isFree: boolean;
  used?: number;
  total?: number;
  remaining?: number;
  startDate?: string;
  endDate?: string;
  uniqueShipments?: {
    total: number | null;
    used: number | null;
    remaining: number | null;
  };
};

export type ShipmentCardMetadataDTO = {
  unique_shipments?: {
    total: number | null;
    used: number | null;
    remaining: number | null;
  };
  daily?: {
    unique_shipments?: {
      total: number | null;
      used: number | null;
      remaining: number | null;
    };
  };
  is_free?: boolean;
  subscription?: {
    unique_shipments?: {
      total: number | null;
      used: number | null;
      remaining: number | null;
    };
    start_date: DateTimeDTO;
    end_date: DateTimeDTO;
  };
};

export class SubscriptionModel {
  constructor(private _model?: ShipmentCardMetadataDTO) {}

  get data(): SubscriptionDataModel | null {
    const metadata = this._model;
    const requiredKeys: (keyof ShipmentCardMetadataDTO)[] = ["is_free", "unique_shipments"];
    if (metadata && requiredKeys.every((key) => key in metadata)) {
      const isFree = metadata.is_free;
      const uniqueShipments = metadata.unique_shipments;
      if (isFree) {
        const dailyPlan = metadata?.daily;
        if (!dailyPlan?.unique_shipments) return null;
        const { total, used, remaining } = dailyPlan.unique_shipments;
        if (!isNumber(total) || !isNumber(used) || !isNumber(remaining)) {
          return null;
        }
        return { total, used, remaining, isFree, uniqueShipments };
      }
      if (!isFree) {
        const paidPlan = metadata?.subscription;
        if (!paidPlan?.unique_shipments) return null;
        const { total, used, remaining } = paidPlan.unique_shipments;
        if (!isNumber(total) || !isNumber(used) || !isNumber(remaining)) {
          return null;
        }
        return {
          total,
          used,
          remaining,
          isFree: false,
          startDate: paidPlan?.start_date,
          endDate: paidPlan?.end_date,
          uniqueShipments,
        };
      }
    }
    return null;
  }
}
